(function () {

  var overlay = document.getElementById('wrxModalOverlay');
  var checkbox = document.getElementById('wrxTermsCheck');
  var goBtn = document.getElementById('wrxModalGo');
  var backBtn = document.getElementById('wrxModalBack');
  var pendingCheckoutUrl = null;
  var lastFocused = null;

  function openModal(checkoutUrl) {
    pendingCheckoutUrl = checkoutUrl;
    checkbox.checked = false;
    goBtn.disabled = true;
    lastFocused = document.activeElement;
    overlay.classList.add('wrx-open');
    checkbox.focus();
  }
  function closeModal() {
    overlay.classList.remove('wrx-open');
    pendingCheckoutUrl = null;
    if (lastFocused) lastFocused.focus();
  }
  checkbox.addEventListener('change', function () { goBtn.disabled = !checkbox.checked; });
  goBtn.addEventListener('click', function () { if (checkbox.checked && pendingCheckoutUrl) window.location.href = pendingCheckoutUrl; });
  backBtn.addEventListener('click', closeModal);
  overlay.addEventListener('click', function (e) { if (e.target === overlay) closeModal(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && overlay.classList.contains('wrx-open')) closeModal(); });

  document.getElementById('wrxUpgradeBtn').addEventListener('click', function () {
    openModal(this.getAttribute('data-wrx-checkout'));
  });
})();
